<template>
  <main>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-75 md-small-size-100">
        <h2 class="md-title">パスワード再発行</h2>
      </div>

      <md-card class="md-layout-item md-size-75 md-small-size-100 mb-40" v-if="!sent">
        <md-card-content>
          <div class="md-layout md-gutter" v-if="errorMessages.length">
            <div class="md-layout-item md-size-100">
              <flash-message :errors="errorMessages"></flash-message>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-35 md-small-size-100">
              <div class="md-title">新しいパスワードの設定</div>
            </div>
            <div class="md-layout-item md-size-65 md-small-size-100">
              <p>新しいパスワードを設定してください。</p>
              <md-card>
                <md-card-content>
                  <div class="md-layout md-alignment-center-center">
                    <div class="md-layout-item">
                      <md-field :class="getValidationClass('password')">
                        <label>新しいパスワード</label>
                        <md-input type="text" v-model="form.password" required autofocus
                                  :disabled="sending || !verify"/>
                        <span class="md-helper-text">例) 英数字記号が含まれた8文字以上</span>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('password')">{{
                            getValidationResponseMessage('password')
                          }}</span>
                        <span class="md-error" v-else-if="!$v.form.password.required">{{
                            errors.password.required
                          }}</span>
                        <span class="md-error" v-else-if="!$v.form.password.minLength">{{
                            errors.password.minLength
                          }}</span>
                        <span class="md-error" v-else-if="!$v.form.password.maxLength">{{
                            errors.password.maxLength
                          }}</span>
                        <span class="md-error" v-else-if="!$v.form.password.password">{{
                            errors.password.password
                          }}</span>
                      </md-field>
                      <md-field :class="getValidationClass('password_confirmation')">
                        <label>パスワードの確認</label>
                        <md-input type="text" v-model="form.password_confirmation" required
                                  :disabled="sending || !verify"/>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('password_confirmation')">{{
                            getValidationResponseMessage('password_confirmation')
                          }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.password_confirmation.required">{{
                            errors.password_confirmation.required
                          }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.password_confirmation.sameAs">{{
                            errors.password_confirmation.sameAs
                          }}</span>
                      </md-field>
                    </div>
                    <div class="md-layout-item ">
                      <md-button class="md-primary md-raised" type="submit" :disabled="sending || !verify"
                                 @click="onSubmit()">
                        <md-icon>save</md-icon>
                        <span>パスワードの再発行</span>
                      </md-button>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
            <div class="md-layout-item md-size-100" v-if="sending">
              <loading-spinner></loading-spinner>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <md-card class="md-layout-item md-size-75 md-small-size-100 mb-40" v-if="sent">
        <md-card-content>
          <h2 class="md-title">新しいパスワードを設定し、確認メールを送信しました。</h2>
          <p>
            ご指定のメールアドレスへメールを送信いたしました。<br>
            メール本文にありますパスワードをご確認ください。
          </p>
          <br>
          <p class="md-body-1">※確認メールが届かない場合、下記をご確認ください。</p>
          <p class="md-caption">
            ・迷惑メールフォルダにメールが振り分けられている可能性がありますので、迷惑メールフォルダも含めご確認ください。<br>
            ・ドメイン指定受信など、一部のメールが届かなくなる設定にしていると、パスワード確認メールが届かない場合があります。<br>
            ・「no-reply@jon-payment.com」または「jon-web_info@jon.co.jp」からのメールを受信できるように設定してください。<br>
            ・メールアドレスを間違って入力した可能性があります。再度「
            <a :href="$router.resolve({name: 'ForgotAccount'}).href">ID・パスワードをお忘れの方</a>
            」より登録を行ってください
          </p>
        </md-card-content>
      </md-card>
    </div>
  </main>
</template>

<script>
import FlashMessage                                         from "../../components/FlashMessage";
import CommonMixin                                          from "../../mixins/commonMixin";
import {validationMixin}                                    from 'vuelidate'
import {apiClient, apiList}                                 from "../../modules/apiClient";
import LoadingSpinner                                       from "../../components/LoadingSpinner";
import LoadingSpinnerOverlay                                from "../../components/LoadingSpinnerOverlay";
import Common                                               from "../../modules/common";
import Validation                                           from "../../modules/validation";
import {maxLength, minLength, required, requiredIf, sameAs} from "vuelidate/lib/validators";

export default {
  name      : 'Reminder',
  components: {LoadingSpinnerOverlay, LoadingSpinner, FlashMessage},
  mixins    : [validationMixin, CommonMixin],
  data      : () => ({
    sending: false,
    sent   : false,
    verify : false,
    form   : {
      token                : null,
      password             : null,
      password_confirmation: null,
    },
    errors : {
      password             : {
        required : Validation.errorMessage(Validation.rules.required, 'password'),
        minLength: Validation.errorMessage(Validation.rules.minLength, 'password', 8),
        maxLength: Validation.errorMessage(Validation.rules.maxLength, 'password', 100),
        password : Validation.errorMessage(Validation.rules.password, 'password'),
      },
      password_confirmation: {
        required: Validation.errorMessage(Validation.rules.required, 'passwordConfirm'),
        sameAs  : Validation.errorMessage(Validation.rules.sameAs, 'password'),
      },
    }
  }),
  validations() {
    return {
      form: {
        password             : {
          required,
          minLength: minLength(this.form.password ? 8 : 0),
          maxLength: maxLength(100),
          password : Validation.password,
        },
        password_confirmation: {
          required,
          sameAs: sameAs('password'),
        },
      },
    };
  },
  mounted() {
    this.getVerifyToken();
  },
  methods: {
    getVerifyToken() {
      this.sending = true;
      apiClient
          .get(apiList.verify_reset_password_token, {
            params: {
              token: this.$route.query.token,
            }
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.errorMessages = [Common.messages.account.tokenNotValid];
              return;
            }
            this.verify     = true;
            this.form.token = this.$route.query.token;
          })
          .catch(error => {
            this.errorMessages = [Common.messages.account.tokenNotValid];
          })
          .finally(() => {
            this.sending = false;
          });
    },
    clearForm() {
      this.successMessage   = [];
      this.errorMessages    = [];
      this.validateResponse = [];
    },
    onSubmit() {
      this.clearForm();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.sending = true;
      apiClient
          .post(apiList.reset_password, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.sent = true;
          })
          .catch(error => {
            this.errorMessages = [error];
          })
          .finally(() => {
            this.sending = false;
          });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.mb-40 {
  margin-bottom: 40px;
}
</style>
